<template lang="pug">
div
  v-dialog(v-model="loadingAsync" width="400" persistent)
    v-card
      v-card-title Синхронизация отчётов
      v-card-text
        v-progress-linear(
          :value="syncPercent"
          color="deep-purple accent-4"
          rounded
          height="8"
        )
        div.mt-2.archive-info Синхронизировано: {{ syncProgress.done }} из {{ syncProgress.total }}
  v-dialog( v-model="loadingReport" width="unset" :persistent="loadingReport" )
    v-card
      v-card-title Загрузка отчетов...
      v-card-text( v-if="loadingReport" )
        v-progress-linear( color="deep-purple accent-4" indeterminate rounded height="6" )

  router-view
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('pointreport', ['loadingAsync', 'syncProgress', 'loadingReport']),

    syncPercent() {
      if (!this.syncProgress.total) return 0
      return Math.round((this.syncProgress.done / this.syncProgress.total) * 100)
    }
  }
}
</script>
<style scoped>
.archive-info {
  font-size: 10px;
  line-height: 22px;
  color: #00000099;
}
</style>